const emptyEstateDocumentsState = {
  estateFilesByFolder: {},
  estateFilesByBp: {},
  estateFolders: [],
  isLoadingEstateFolders: false,
  estateOwnedFiles: [],
  estateOwnedFilesMeta: { currentPage: 1, lastPage: 1, total: 0 },
  estateOwnedFilesFolderId: null,
  estateOwnedFilesRequestedFolderId: null,
  lastAggregateQuery: {},
  loadedFolders: new Set(),
  loadingFolders: new Set(),
  isLoadingEstateOwnedFiles: false,
  uploadingEstateDocumentCount: 0,
  loadingProgress: {},
  cursorByKey: {},
  hasMoreByKey: {},
  searchResults: [],
  searchMeta: { truncated: false, limit: null },
  isSearchingEstateFiles: false,
  folderUserCounts: {}
}

export default emptyEstateDocumentsState
